export default {
  filters: {
    truncate(text, stop) {
      return text.slice(0, stop) + (stop < text.length ? '...' : '')
    },
  },
};
